import { Box, Button, Text } from '@chakra-ui/react'
import { Icon } from 'components/atoms'
import React from 'react'
import { TEXT } from './constants'
import { NotExistProps } from './interfaces'

export const NotExist: React.FC<NotExistProps> = ({
    action,
    isBackoffice,
    ...props
}) => {
    const message = action && (action.custom ?? TEXT[action.text])

    return (
        <>
            <Box
                data-testid="notExist-wrapper"
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap={7}
                {...props}
            >
                <Icon data-testid="notExist_icon" name="ghost" size={56} />
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                >
                    <Text fontWeight={700} fontSize={28} color="grayscale.800">
                        Não existe nada aqui.
                    </Text>
                    {action && isBackoffice ? (
                        <Button
                            data-testid="notExist-button"
                            background="transparent"
                            fontSize={'16'}
                            fontWeight={400}
                            textDecoration={
                                action?.custom || action.text === 'search'
                                    ? 'none'
                                    : 'underline'
                            }
                            color="grayscale.800"
                            cursor={
                                action?.custom || action.text === 'search'
                                    ? 'default'
                                    : 'pointer'
                            }
                            _hover={{
                                background: 'transparent'
                            }}
                            _active={{
                                background: 'transparent'
                            }}
                            {...action}
                        >
                            {message}
                        </Button>
                    ) : (
                        <Text
                            background="transparent"
                            fontSize={'16'}
                            fontWeight={400}
                            color="grayscale.800"
                        >
                            {message}
                        </Text>
                    )}
                </Box>
            </Box>
        </>
    )
}
